export const siteInfo = {
  name: 'Darren Flowers-Finley',
  tagline: 'Real-Time Cinematics & Virtual Production',
  bio: 'Cinematic Generalist and Technical Artist — Unreal Engine cinematics, character systems, and pipelines that ship.',
  email: 'darrenflowers17@gmail.com',
  linkedin: 'https://www.linkedin.com/in/darren-flowers-finley-218aaa117/',
  copyright: '© 2025 Darren Flowers-Finley. All rights reserved.',
}

export const showreelContent = {
  title: 'Showreel',
  description:
    'Selected real-time cinematics, character work, and virtual production.',
  video: '/videos/showreel.mp4',
  poster: '/images/showreel-poster.jpg',
}

export const navLinks = [
  {
    to: '/',
    label: 'showreel',
    subtitle: 'reel',
    icon: 'showreel',
  },
  {
    to: '/contact',
    label: 'contact',
    subtitle: "what's up?",
    icon: 'contact',
  },
  {
    to: '/about',
    label: 'about',
    subtitle: 'me',
    icon: 'about',
  },
]

export const projects = [
  // Optional media per project:
  // previewVideo: '/videos/project-id-preview.mp4'
  // heroVideo: '/videos/project-id-hero.mp4'
  // previewPoster: '/images/project-id-poster.jpg'
  // iconImage: '/images/project-id-icon.png'
  {
    id: 'anim-8',
    title: 'Anim-8',
    category: 'cinematics',
    categoryLabel: 'Cinematics / Animation',
    platformLabel: 'Real-Time Cinematics',
    shortDescription:
      'Lead cinematic and lighting artist for animation studio',
    year: '2025–2026',
    featured: true,
    sidebarSubtitle: 'lighting, vfx & technical artist',
    iconImage: '/images/anim-8-icon.png',
    previewVideo: '/videos/anim-8-preview.mp4',
    heroVideo: '/videos/anim-8-preview.mp4',
    previewPoster: '/images/anim-8-poster.jpg',
    themeColor: '#5b8def',
  },
  {
    id: 'sakira-mods',
    title: 'Sakira Mods',
    category: 'animation',
    categoryLabel: 'Animation / Characters',
    platformLabel: 'Character Series',
    shortDescription:
      'Lead Technical and Cinematic Artist — 400K+ followers and 1M+ views across the series.',
    year: '2023–2024',
    featured: true,
    sidebarSubtitle:
      'full pipeline — animation, cinematics & unreal integration',
    iconImage: '/images/sakira-mods-icon.png',
    previewVideo: '/videos/sakira-mods-preview.mp4',
    heroVideo: '/videos/sakira-mods-preview.mp4',
    previewPoster: '/images/sakira-mods-poster.jpg',
    themeColor: '#e06a45',
  },
]

export const featuredProjects = projects.filter((project) => project.featured)

export const aboutContent = {
  headline: 'What I Do',
  body: [
    "I'm a Cinematic Generalist and Technical Artist with 10+ years in Unreal Engine — real-time cinematics, character systems, and pipelines that actually ship. The last 5 of those years I've spent making social media content in Unreal, including projects like Sakira Mods (400K+ followers), Anim-8, Dinosaur named Slickback, FNMeka and FNNxrmal, and bigger collaborative work where someone has to own the messy middle.",
  ],
  stats: [
    { value: '400K+', label: 'Followers on Sakira Mods' },
    { value: '117.3K', label: 'Followers on FNNxrmal' },
    { value: '79.2K', label: 'Followers on A Dinosaur Named Slickback' },
    { value: '255M+', label: 'Views across all platforms' },
    { value: '10+ years', label: 'Building in Unreal' },
    { value: '2 years', label: 'Social media content in Maya' },
  ],
  bio: [
    'I was born in Tacoma, Washington, in 1994. I grew up in a military family, moving all over the world from Minnesota, Georgia, Germany, and Kentucky before eventually landing in Utah, where I live now. Living in so many places opened my eyes to something simple: even though we all look different, when you boil it down, we\'re a lot more alike than you\'d think.',
    "In 2012 I attended the University of Utah, where I later earned my Master's in the EAE program for creating video games in 2019. Soon after, I got a job at Collins Aerospace as a 3D modeler for their simulation systems for Boeing. During my time there I produced music in my free time and ran a virtual influencer named FN Nxrmal under the FN Meka brand, helping create content for Meka and performing as a solo artist for Nxrmal. During that time, one of my songs got included in one of Tyler Perry's shows on BET, which was a huge blessing.",
    'After about a year of that, I moved on to work with RTFKT (a shoe design and NFT company that was later acquired by Nike) as a 3D Modeler. From there I slowly got back into creating content, this time with a character called A Dinosaur Named Slickback. I actually used that project as a way to teach myself Blender. Within about three months I\'d grown that account to around 79.2K followers, all organic.',
    'Not long after, I realized creating content as a solo artist was rough. So I decided to team up with the creator of FN Meka instead. Together we created Sakira Mods, a virtual influencer that modded cars into these out of this world designs. My role was all over the place. I was rigger, animator, filmer, Vicon system tech, voice actor, you name it. It was intense, but we ended up creating a character that really resonated with people.',
    'These days I work with Anim8, helping them create content for other clients. Outside of work, I love golfing and playing video games.',
  ],
  primarySkills: [
    'Unreal Engine 5 (Sequencer, Movie Render Queue, Blueprints)',
    'Vcam & Camera Direction',
    'Motion Capture (Vicon) & Retargeting',
    'Character Animation & Performance',
    'Unreal Control Rig System',
    'MetaHuman Integration & Customization',
    'In-Engine Compositing & Rendering',
    'Maya, MotionBuilder, Substance Painter, After Effects',
    'Python (Unreal Python API, pipeline scripting)',
  ],
}

export const contactContent = {
  headline: "Let's Build Something Cinematic",
  body: 'Got an idea? Need a technical artist on your project? Interested in collaboration?',
  confirmation: "Thanks for reaching out! I'll get back to you within 24 hours.",
  error: `That didn't send. Please try again, or email me directly at ${siteInfo.email}.`,
}
